module.exports = __webpack_public_path__ + "img/1.26c48af9.jpg";